import React, { useState } from "react";
import Modal from "./Modal";

export const Image = ({ title, largeImage, smallImage }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const [message, setMessage] = useState("");

  function abrirModal() {
    setIsModalOpen(true);
    setTxt("imagen");
    setMessage(largeImage);
}

  const handleSubmit = async (e) => {
    e.preventDefault();
    abrirModal();
  }

  return (
    <div className="portfolio-item">
      <Modal isOpen={isModalOpen} msg={message} txt={txt} title={title} closeModal={() => setIsModalOpen(false)} />
      <div className="hover-bg">
        {" "}
        <button onClick={handleSubmit} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />{" "}
        </button>{" "}
      </div>
    </div>
  );
};
